module.exports = __webpack_public_path__ + "static/media/software.bb375cdd.gif";